var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStateConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C6.9595 0 0 6.9595 0 15.5C0 24.0405 6.9595 31 15.5 31C24.0405 31 31 24.0405 31 15.5C31 6.9595 24.0405 0 15.5 0Z",
    fill: "#6DD684"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4991 1.40918C7.73502 1.40918 1.4082 7.736 1.4082 15.5001C1.4082 23.2642 7.73502 29.591 15.4991 29.591C23.2632 29.591 29.59 23.2642 29.59 15.5001C29.59 7.736 23.2632 1.40918 15.4991 1.40918Z",
    fill: "#43B75D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2325 12.2591L18.2377 16.2539L14.2429 20.2486C14.0456 20.4459 13.7779 20.5586 13.4961 20.5586C13.2143 20.5586 12.9466 20.4459 12.7493 20.2486L8.76156 16.2609C8.35292 15.8523 8.35292 15.1759 8.76156 14.7673C9.17019 14.3586 9.84656 14.3586 10.2552 14.7673L13.4961 18.0082L20.7388 10.7655C21.1475 10.3568 21.8238 10.3568 22.2325 10.7655C22.6411 11.1741 22.6411 11.8364 22.2325 12.2591Z",
    fill: "#92EBA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateConfirmed);
export default __webpack_public_path__ + "static/media/StateConfirmed.8af24642109675f6b5051220e921bfe6.svg";
export { ForwardRef as ReactComponent };